// NewEvent.js

import React, { Component } from 'react';
import Form from "react-jsonschema-form";
import JSONSchemaForm from "react-jsonschema-form";
import { connect } from 'react-redux';
import { updateAlert } from '../actions/alert-actions';
import { addToCart } from '../actions/cart-actions';
import moment from 'moment';


class NewEvent extends Component {
  constructor(props) {
    super(props);
    var defaultStart = null;
    if (props.match.params.start) {
      var startMoment = new moment(props.match.params.start, 'YYYYMMDDHHmm');
      defaultStart = startMoment.format('YYYY-MM-DDTHH:mm:ss');
    }
    var defaultEnd = null;
    if (props.match.params.end) {
      var endMoment = new moment(props.match.params.end, 'YYYYMMDDHHmm');
      defaultEnd = endMoment.format('YYYY-MM-DDTHH:mm:ss');
    }
    console.log(props);
    this.state = {
      defaultStart: 'asdsad',
      Form: JSONSchemaForm.default,
      jsonSchema: {
      "title": "New Booking",
      "description": "Please enter information for a new booking request",
      "type": "object",
      "required": [
        "start",
        "end",
        "type"
      ],
      "properties": {
        "type": {
          "type": "string",
          "title": "Event Type",
          "enum"  : ['Reservation', 'Practice', 'Game', 'Camp', 'Zamboni', 'Closure']
        },
        "start": {
          "type": "string",
          "title": "Start Time",
          "default": defaultStart
        },
        "end": {
          "type": "string",
          "title": "End Time",
          "default": defaultEnd
        }
      },
      "dependencies": {
        "type": {
          "oneOf": [
            {
              "properties": {
                "type": {
                  "enum": [
                    "Closure"
                  ]
                },
                "title": {
                  "type": "string",
                  "title": "Reservation Title",
                  "default": "Closed - "
                }
              },
              "required": [
                "title"
              ]
            },
            {
              "properties": {
                "type": {
                  "enum": [
                    "Zamboni"
                  ]
                },
                "title": {
                  "type": "string",
                  "title": "Reservation Title",
                  "default": "Zamboni"
                }
              },
              "required": [
                "title"
              ]
            },
            {
              "properties": {
                "type": {
                  "enum": [
                    "Reservation"
                  ]
                },
                "title": {
                  "type": "string",
                  "title": "Reservation Title",
                },
                "notes": {
                  "type": "string",
                  "title": "Additional Information/Comments"
                }
              },
              "required": [
                "title"
              ]
            },
            {
              "properties": {
                "type": {
                  "enum": [
                    "Camp"
                  ]
                },
                "title": {
                  "type": "string",
                  "title": "Camp Name",
                },
                "notes": {
                  "type": "string",
                  "title": "Additional Information/Comments"
                }
              },
              "required": [
                "title"
              ]
            },
            {
              "properties": {
                "type": {
                  "enum": [
                    "Game"
                  ]
                },
                "home_team": {
                  "type": "string",
                  "title": "Home Team",
                  "default": "BMHA"
                },
                "away_team": {
                  "type": "string",
                  "title": "Away Team",
                  "default": "TBD"
                },
                "refs": {
                  "type": "boolean",
                  "title": "Refs Required"
                },
                "divider": {
                  "type": "boolean",
                  "title": "Half-ice Divider"
                },
                "title": {
                  "type": "string",
                  "title": "Camp Name",
                },
                "notes": {
                  "type": "string",
                  "title": "Additional Information/Comments"
                }
              },
              "required": [
              ]
            },
            {
              "properties": {
                "type": {
                  "enum": [
                    "Practice"
                  ]
                },
                "home_team": {
                  "type": "string",
                  "title": "Team",
                  "default": "BMHA"
                },
                "title": {
                  "type": "string",
                  "title": "Practice Name",
                  "readOnly": true
                },
                "notes": {
                  "type": "string",
                  "title": "Additional Information/Comments"
                }
              },
              "required": [
              ]
            }
          ]
        }
      }
    },
    uiSchema: {
      "type": {
        "ui:autofocus": true,
        "ui:widget": "select"
      },
      "age": {
        "ui:widget": "select"
      },
      "notes": {
        "ui:widget": "textarea",
 //       "ui:help": "Hint: Make it strong!"
      },
      "start": {
        "ui:widget": "date-time"
      },
      "end": {
        "ui:widget": "date-time"
      }
    }
  }


    
  }


makeSeries(button) {
    //console.log("makeSeries button pushed: " + button);
    this.props.history.push('/newSeries/' + this.props.match.params.start + '/' + this.props.match.params.end);
}

/*onAddToCart(message, type){
  this.props.onAddToCart(message, type);
}*/

onSubmit(formData) {
  //console.log('formData', formData.formData);
  /*var zStart = formData.formData.end;
  var zEnd = new moment(zStart).add(15, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
  /var payload = [
    formData.formData,
    {
      start: zStart,
      end: zEnd,
      title: 'Zamboni',
      type: 'Zamboni'
    }
  ]*/
  //this.props.onAddToCart(payload)
  var response = fetch('https://beisekerice.com/api/v0/events', {
    //    var response = fetch('https://beisekerice.com/api/v0/register', {
    //  var response = fetch('http://localhost:3001/api/v0/register', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Token ' + this.props.user.token
          },
          body: JSON.stringify(formData.formData)
        }).then(response => {
          console.log('response', response);
          if (!response.ok) {
              console.log(response.statusText);
              return Promise.reject(response.statusText);
          }
          //console.log(response.statusText);
          this.props.onUpdateAlert("");
          this.props.history.push(`/admin`);
          //return response.json();
      })
      .catch(error => {
        console.log(error);
        this.props.onUpdateAlert("Unable to create event");
      });
}

componentDidMount() {
  if (!this.props.user) {
    this.props.history.push('/login');
  }
}

render() {
    return (
      <div class="eventView">
        <div className="container">
            <div className="col-sm-6 offset-sm-3 mt-2">
                {this.props.alert &&
                    <div className={'alert alert-warning'}>{this.props.alert}</div>
                }
            </div>
        </div>
        <div>
          <button id='series' className='btn btn-info' onClick={this.makeSeries.bind(this)}>Make Series</button>
        </div>
      <Form schema={this.state.jsonSchema}
        className="form form-wide"
        uiSchema={this.state.uiSchema}
        onSubmit={this.onSubmit.bind(this)} />
        <div>
        <button id='back' className='btn btn-info' onClick={this.props.history.goBack}>Back</button>
        </div>

    </div>
    );
  }
}




const mapStateToProps = state => ({
  cart: state.cart,
  user: state.user,
  alert: state.alert
});

const mapActionsToProps = {
  onUpdateAlert: updateAlert,
  onAddToCart: addToCart
};

export default connect(mapStateToProps, 
  mapActionsToProps
  )(NewEvent);



// WEBPACK FOOTER //
// ./src/components/NewEvent.js